module.exports = __webpack_public_path__ + "img/white-outline-eye-20x20.6c090428.svg";